import { createSlice } from "@reduxjs/toolkit";
import { stripHeavyFields } from "../utils/multiGym";

const initialState = {
  userInfo: localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : null,
};

// With multiple gyms parked inside myGyms, userInfo can outgrow the
// localStorage quota. Redux always keeps the full object; storage falls back
// to slimmer versions instead of throwing.
const persistUserInfo = (userInfo) => {
  try {
    localStorage.setItem("userInfo", JSON.stringify(userInfo));
  } catch (e) {
    try {
      const slim = {
        ...userInfo,
        myGyms: (userInfo?.myGyms || []).map(stripHeavyFields),
      };
      localStorage.setItem("userInfo", JSON.stringify(slim));
    } catch (e2) {
      try {
        const activeOnly = { ...userInfo };
        delete activeOnly.myGyms;
        localStorage.setItem("userInfo", JSON.stringify(activeOnly));
      } catch (e3) {
        console.error("Failed to persist userInfo", e3);
      }
    }
  }
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      state.userInfo = action.payload;
      persistUserInfo(action.payload);
    },
    logout: (state, action) => {
      try {
        state.userInfo = null;
        localStorage.removeItem("userInfo");
        if (localStorage.getItem("userInfo") !== null) {
          localStorage.removeItem("userInfo");
          state.userInfo = null;
        }
      } catch (e) {
        localStorage.removeItem("userInfo");
        state.userInfo = null;
      }
    },
  },
});

export const { setCredentials, logout } = authSlice.actions;

export default authSlice.reducer;
